export default ['none', 'birthday'];
